import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle, faCircleCheck, faFileExclamation, faInfo } from '@fortawesome/pro-solid-svg-icons';
import PropTypes from 'prop-types';
import Skeleton from 'react-loading-skeleton';
import { useState } from 'react';
import QuestionPropertiesModal from '../castleQuestionsSearch/components/QuestionPropertiesModal';
import CustomToast from '../../../../components/Toast';
import { useGetQuestionPropertiesMutation } from '../../../../features/authentication/assignmentApislice';
import AssignmentsUsedBy from '../AssignmentsUsedBy';

const MathSkillQuestionThumbnail = ({ questions, setMathSkillQuestions, selectedQuestionIds, setSelectedQuestionIds, isLoading, showQuestionUsage, selectedCourseId, isSelectedOnly }) => {

  const [getQuestionProperties] = useGetQuestionPropertiesMutation();

  const [showUsedByModal, setShowUsedByModal] = useState(false);
  const [usedAssignments, setUsedAssignments] = useState([]);
  const [showQuestionPropertiesModal, setShowQuestionPropertiesModal] = useState(false);
  const [propertiesResult, setPropertiesResult] = useState([]);
  const [isPropertiesLoading, setIsPropertiesLoading] = useState(false);

  const handleSetSelection = (questionId, selected) => {
    let newMathSkillQuestions = questions.map((item) =>
      item.questionId === questionId ? { ...item, isSelected: selected } : item
    );
    const currentSelectedQuestionIds = [...selectedQuestionIds];
    if (selected)
      currentSelectedQuestionIds.push(questionId);
    else {
      const index = currentSelectedQuestionIds.findIndex(integer => integer === questionId);
      if (index !== -1) {
        currentSelectedQuestionIds.splice(index, 1);
      }
    }
    setSelectedQuestionIds(currentSelectedQuestionIds);
    setMathSkillQuestions(newMathSkillQuestions);
  };

  const handleUsedBy = (assignments) => {
    setUsedAssignments(assignments);
    setShowUsedByModal(true);
  };

  const handleProperties = (questionId) => {
    setShowQuestionPropertiesModal(true);
    getQuestionPropertiesAsync(questionId);
  };

  const getQuestionPropertiesAsync = async (questionId) => {
    setIsPropertiesLoading(true);
    try {
      const options = {
        questionId: questionId,
        courseId: selectedCourseId,
        assignmentId: 0
      };
      const response = await getQuestionProperties(options);
      if (response.error) {
        if(response.error?.data?.error)
          CustomToast(response.error.data.error, 'error');
        setShowQuestionPropertiesModal(false);
      }
      else {
        setPropertiesResult(response);
      }
    } catch (error) {
      console.log(error);
    }
    setIsPropertiesLoading(false);
  };

  return (
    <>
      {!isLoading ? (
        <>
          {
            questions.map((question, index) => (
              <>
                {((isSelectedOnly && selectedQuestionIds.includes(question.questionId)) || !isSelectedOnly) &&
              <>
                {question.isSearchFind &&
                  <div key={index} className='questionThumbnail justify-content-start h-auto mb-4'>
                    <div className='skill-select-button'>
                      <div className='d-flex flex-row justify-content-between'>
                        <div></div>
                        <div className='questionThumbnailButtons' onClick={() => handleSetSelection(question.questionId, !question.isSelected)}>
                          {question.isSelected ?
                            <FontAwesomeIcon color='#52C9A5' icon={faCircleCheck} />
                            :
                            <FontAwesomeIcon color='#d4deff' icon={faCircle} />}
                        </div>
                      </div>
                    </div>
                    <div className='d-flex gap-2'>
                      <div>ID {question.questionId}</div>
                      <div className='editInfoBtn cursor-pointer d-flex gap-1 text-warning' onClick={() => handleProperties(question.questionId)}>
                        <FontAwesomeIcon className='fs-5 mx-1 info-orange' icon={faInfo} />
                        <div className='editInfoDescription fw-500'>Properties</div>
                      </div>
                      {question.usedAssignments.length > 0 && showQuestionUsage &&
                        <div className='d-flex gap-2' onClick={() => handleUsedBy(question.usedAssignments)}>
                          <div className='editInfoBtn d-flex gap-1 text-warning' >
                            <FontAwesomeIcon className='fs-5 mx-1' icon={faFileExclamation} />
                            <div className='editInfoDescription fw-500'>Used By</div>
                          </div>
                          <div>({question.usedAssignments.length})</div>
                        </div>
                      }
                    </div>
                    <p dangerouslySetInnerHTML={{ __html: question.question }}></p>
                  </div>
                }
              </>}
              </>
            ))
          }
        </>
      ) :
        (
          <div className="w-100 row">
            {[...Array(1)].map((_, index) => (
              <div className='col-12 mb-3 h-40' key={index}>
                <Skeleton />
              </div>
            ))}
            {[...Array(4)].map((_, index) => (
              <div className='col-12 mb-3 h-40' key={index}>
                <Skeleton />
              </div>
            ))}
          </div>
        )
      }
      {showUsedByModal &&
        <AssignmentsUsedBy
          usedAssignments={usedAssignments}
          showUsedByModal={showUsedByModal}
          setShowUsedByModal={setShowUsedByModal}
        />
      }
      {showQuestionPropertiesModal &&
        <QuestionPropertiesModal
          setShowQuestionPropertiesModal={setShowQuestionPropertiesModal}
          showQuestionPropertiesModal={showQuestionPropertiesModal}
          propertiesResult={propertiesResult}
          setPropertiesResult={setPropertiesResult}
          isSearchQuestion={false}
          isLoading={isPropertiesLoading}
        />
      }
    </>
  );
};

MathSkillQuestionThumbnail.propTypes = {
  questions: PropTypes.array.isRequired,
  setMathSkillQuestions: PropTypes.func,
  selectedQuestionIds: PropTypes.array,
  setSelectedQuestionIds: PropTypes.func,
  isLoading: PropTypes.bool,
  showQuestionUsage: PropTypes.bool,
  selectedCourseId: PropTypes.number,
  isSelectedOnly: PropTypes.bool
};

export default MathSkillQuestionThumbnail;
